import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    OnInit,
    AfterViewInit,
    Output,
    ViewEncapsulation,
    ChangeDetectorRef
} from '@angular/core';
import {ManagementFacadeService} from '@emm/management/services/management-facade.service';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'emm-management-layout',
    styleUrls: ['./management-layout.component.scss'],
    templateUrl: './management-layout.component.html'
})
export class ManagementLayoutComponent implements OnInit, AfterViewInit {

    @Output() add = new EventEmitter();
    @Output() collapse = new EventEmitter();

    selectedScreen$ = this.managementFacade.selectedScreen$;
    isMangLoading$ = this.managementFacade.isLoading$;

    constructor(private managementFacade: ManagementFacadeService,
                 private changeDetector: ChangeDetectorRef) {}

    ngOnInit(): void {}

    ngAfterViewInit() {
        this.changeDetector.detectChanges();
    }
}
